import React, { useState, useEffect } from 'react';

const CompletedProjects = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState({});
  const [hoveredImage, setHoveredImage] = useState({});

  const projects = [
    {
      id: 1,
      name: 'Capital ARK',
      location: 'Raikal Village, Farooq Nagar Mandal, Ranga Reddy District',
      type: 'Open Plots',
      developer: 'NAKSHATRA INFRA PROJECTS',
      mainImage: 'https://i.pinimg.com/originals/ed/08/a2/ed08a2b494b07047ddff2650ba891e05.jpg',
      galleryImages: [
        'https://www.hyderabadzone.com/wp-content/uploads/2022/09/Real-Estate-Companies-in-Hyderabad-for-Open-Plots.webp',
        'https://varenya.co/wp-content/uploads/2024/02/imark-prime-location.jpg',
        'https://www.hmdaplots.in/wp-content/uploads/2023/04/open-plots.jpeg',
        'https://i.ibb.co/7vGVcrn/open-plots.jpg'
      ],
      description: 'Shadnagar is one of the fastest-growing municipality zones with strong future growth potential. It is a wise and profitable investment destination due to its close proximity to Hyderabad and Bangalore Highway (NH-44). The location is surrounded by major developments such as Wipro, Industrial Zone SEZ, NRSA, TISS Campus, the International Airport, amusement parks, and other key infrastructure projects. This project is thoughtfully designed for visionary investors seeking long-term value and high profitability.',
      plotSizes: 'Survey No. 218 - Various Sizes',
      totalPlots: 'Residential Plots Layout',
      amenities: [
        'DTCP Approved Layout',
        'Rainwater Harvesting Pits',
        'Underground Drainage System',
        'BT Roads',
        'Avenue Plantation',
        'Electricity Connection',
        'Children\'s Park',
        'Fencing Around Community',
        'Proposed 33 Feet Wide Roads',
        'Existing 33 Feet Wide Roads',
        'Reserved Public Purpose Areas'
      ],
      dtcpApproved: true,
      reraApproved: true,
      completedYear: 2023,
      certifications: [
        'ISO 9001:2015 Certified',
        'L.P No: G87/2020/HR/H',
        'Draft Layout No: 19/2020/HR/H'
      ],
      specialOffers: [
        'Spot Registration Available',
        'Pay ₹5 Lakhs and Get 5 Grams Gold Coin',
        'Register Within One Week and Get 10 Grams Gold Coin Free'
      ],
      highlights: [
        'Project Development by the Company',
        'Clear Title Development as per DTCP Layout',
        'Pattern of Residential Plots',
        'Close to NH-44 (Hyderabad-Bangalore Highway)'
      ]
    },
    {
      id: 2,
      name: 'Green Meadows',
      location: 'Shadnagar',
      type: 'Open Plots',
      developer: 'NAKSHATRA INFRA PROJECTS',
      mainImage: 'https://knox-groups.com/assets/img/real-estate/img-8.jpg',
      galleryImages: [
        'https://knox-groups.com/assets/img/real-estate/img-8.jpg',
  'https://www.hyderabadzone.com/wp-content/uploads/2022/09/Real-Estate-Companies-in-Hyderabad-for-Open-Plots.webp',
  'https://www.hmdaplots.in/wp-content/uploads/2023/04/open-plots.jpeg',
  'https://fortunebutterflycity.com/wp-content/uploads/2015/02/BFC-Land-copy.jpg'
      ],
      description: '15 Acres premium gated township with road facing. Green Meadows offers 100% Vaastu compliant plots with clear title and immediate registration. Developed by NAKSHATRA INFRA PROJECTS with ISO 9001:2015 certification, this beautifully designed project features an elegant entrance arch and is the best choice for investment with comprehensive amenities and modern infrastructure.',
      plotSizes: 'Starting from 167 sq. yards',
      totalPlots: 'Premium Gated Township',
      amenities: [
        'Black Top Roads',
        'Gated Community with 24hrs Security',
        'DTCP Approved Layout',
        'Avenue Plantation',
        'Children Play Ground',
        'Foot Paths',
        'Green Walkways',
        'Street Lights',
        'Overhead Water Tank with Pipelines',
        'Well Developed Park & Common Area',
        'Beautifully Designed Entrance Arch',
        '100% Vaastu & Clear Title',
        'Rainwater Harvesting Pits',
        'Underground Drainage System'
      ],
      dtcpApproved: true,
      reraApproved: true,
      completedYear: 2022,
      certifications: [
        'ISO 9001:2015 Certified'
      ],
      highlights: [
        '15 Acres Premium Township',
        'Road Facing Location',
        'Immediate Registration',
        'Best Project for Investment',
        'Project Development by the Company',
        'Clear Title Development as per DTCP Layout'
      ]
    },
    {
      id: 3,
      name: 'Siri Homes',
      location: 'Sadashivpet',
      type: 'Open Plots',
      developer: 'NAKSHATRA INFRA PROJECTS',
      mainImage: 'https://www.hmdaplots.in/wp-content/uploads/2023/04/open-plots.jpeg',
      galleryImages: [
       'https://knox-groups.com/assets/img/real-estate/img-8.jpg',

  // Indian open plots with clear markings & development
  'https://fortunebutterflycity.com/wp-content/uploads/2015/02/BFC-Land-copy.jpg',

  // HMDA/DTCP-style open plots with blacktop roads
  'https://www.hmdaplots.in/wp-content/uploads/2023/04/open-plots.jpeg',

  // Gated community open plot layout with greenery
  'https://images.pexels.com/photos/460621/pexels-photo-460621.jpeg?auto=compress&cs=tinysrgb&w=800'
      ],
      description: 'Siri Homes presents thoughtfully designed open plots in the peaceful surroundings of Sadashivpet. Developed by NAKSHATRA INFRA PROJECTS with ISO 9001:2015 certification, this project offers clear titles and comprehensive infrastructure. Perfect for families looking to build their dream homes in a well-connected yet tranquil environment with excellent investment potential and modern amenities.',
      plotSizes: '200 - 400 sq. yards',
      totalPlots: 'Premium Residential Layout',
      amenities: [
        'DTCP Approved Layout',
        'Rainwater Harvesting Pits',
        'Underground Drainage System',
        'BT Roads',
        'Avenue Plantation',
        'Electricity Connection',
        'Children\'s Park',
        'Fencing Around Community',
        'Landscaped Gardens',
        'Underground Cabling',
        'Entrance Arch',
        'Club House'
      ],
      dtcpApproved: true,
      reraApproved: true,
      completedYear: 2023,
      certifications: [
        'ISO 9001:2015 Certified'
      ],
      highlights: [
        'Project Development by the Company',
        'Clear Title Development as per DTCP Layout',
        'Jogging Track & Water Harvesting',
        'Peaceful & Well-Connected Location'
      ]
    }
  ];

  useEffect(() => {
    // Removed auto-sliding functionality
  }, []);

  const styles = {
    container: {
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      backgroundColor: '#f8f9fa',
      padding: '60px 0'
    },
    header: {
      textAlign: 'center',
      marginBottom: '60px',
      padding: '0 20px'
    },
    title: {
      fontSize: '48px',
      fontWeight: '700',
      color: '#1a1a1a',
      marginBottom: '16px',
      letterSpacing: '-1px'
    },
    subtitle: {
      fontSize: '18px',
      color: '#666',
      maxWidth: '600px',
      margin: '0 auto'
    },
    projectSection: {
      maxWidth: '1400px',
      margin: '0 auto 80px',
      padding: '0 20px'
    },
    projectLayout: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: '60px',
      alignItems: 'start',
      backgroundColor: '#fff',
      borderRadius: '16px',
      padding: '40px',
      boxShadow: '0 4px 24px rgba(0,0,0,0.08)'
    },
    imageColumn: {
      position: 'relative'
    },
    mainImage: {
      width: '100%',
      height: '450px',
      objectFit: 'cover',
      borderRadius: '12px',
      boxShadow: '0 8px 24px rgba(0,0,0,0.12)'
    },
    galleryContainer: {
      marginTop: '20px',
      display: 'flex',
      gap: '12px',
      position: 'relative'
    },
    thumbnailWrapper: {
      flex: '1',
      height: '100px',
      position: 'relative',
      cursor: 'pointer',
      overflow: 'hidden',
      borderRadius: '8px',
      transition: 'transform 0.3s ease'
    },
    thumbnailImage: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      display: 'block'
    },
    thumbnailOverlay: {
      position: 'absolute',
      inset: '0',
      backgroundColor: 'rgba(0,0,0,0.3)',
      transition: 'background-color 0.3s ease'
    },
    contentColumn: {
      display: 'flex',
      flexDirection: 'column',
      gap: '24px'
    },
    projectName: {
      fontSize: '36px',
      fontWeight: '700',
      color: '#1a1a1a',
      marginBottom: '8px'
    },
    locationTag: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '8px',
      fontSize: '16px',
      color: '#555',
      marginBottom: '16px'
    },
    badges: {
      display: 'flex',
      gap: '12px',
      flexWrap: 'wrap',
      marginBottom: '8px'
    },
    badge: {
      backgroundColor: '#10b981',
      color: '#fff',
      padding: '8px 16px',
      borderRadius: '6px',
      fontSize: '13px',
      fontWeight: '600',
      display: 'flex',
      alignItems: 'center',
      gap: '6px'
    },
    reraBadge: {
      backgroundColor: '#2563eb'
    },
    description: {
      fontSize: '16px',
      color: '#555',
      lineHeight: '1.8',
      marginBottom: '8px'
    },
    infoGrid: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: '16px',
      marginBottom: '8px'
    },
    infoCard: {
      backgroundColor: '#f8f9fa',
      padding: '16px',
      borderRadius: '8px'
    },
    infoLabel: {
      fontSize: '13px',
      color: '#888',
      marginBottom: '6px',
      fontWeight: '600',
      textTransform: 'uppercase'
    },
    infoValue: {
      fontSize: '18px',
      color: '#1a1a1a',
      fontWeight: '600'
    },
    amenitiesSection: {
      marginTop: '8px'
    },
    sectionTitle: {
      fontSize: '18px',
      fontWeight: '600',
      color: '#1a1a1a',
      marginBottom: '16px'
    },
    amenitiesGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(2, 1fr)',
      gap: '12px'
    },
    amenityItem: {
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
      fontSize: '14px',
      color: '#555'
    },
    checkmark: {
      color: '#10b981',
      fontSize: '18px',
      fontWeight: '700'
    },
    certificationBox: {
      backgroundColor: '#f0f9ff',
      padding: '16px',
      borderRadius: '8px',
      marginTop: '16px',
      border: '1px solid #bfdbfe'
    },
    certificationItem: {
      fontSize: '13px',
      color: '#1e40af',
      marginBottom: '6px',
      fontWeight: '500'
    },
    offerBox: {
      backgroundColor: '#fef3c7',
      padding: '16px',
      borderRadius: '8px',
      marginTop: '16px',
      border: '1px solid #fbbf24'
    },
    offerItem: {
      fontSize: '13px',
      color: '#92400e',
      marginBottom: '6px',
      fontWeight: '500',
      display: 'flex',
      alignItems: 'center',
      gap: '8px'
    },
    developerTag: {
      fontSize: '13px',
      color: '#666',
      fontWeight: '600',
      marginBottom: '4px',
      textTransform: 'uppercase',
      letterSpacing: '0.5px'
    }
  };

  return (
    <div style={styles.container}>
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @media (max-width: 1024px) {
          .project-layout {
            grid-template-columns: 1fr !important;
            gap: 40px !important;
          }
        }
      `}</style>

      <div style={styles.header}>
        <h1 style={styles.title}>🏗️ Completed Projects</h1>
        <p style={styles.subtitle}>
          Premium open plots with DTCP & RERA approval, delivering quality and trust
        </p>
      </div>

      {projects.map((project, index) => (
        <div key={project.id} style={styles.projectSection}>
          <div 
            style={styles.projectLayout} 
            className="project-layout"
          >
            {/* Alternate layout: odd projects have images on left, even on right */}
            {index % 2 === 0 ? (
              <>
                {/* Image Column - Left */}
                <div style={styles.imageColumn}>
                  <img 
                    src={project.mainImage} 
                    alt={project.name}
                    style={styles.mainImage}
                  />
                  <div style={styles.galleryContainer}>
                    {project.galleryImages.map((img, idx) => (
                      <div 
                        key={idx}
                        style={styles.thumbnailWrapper}
                        onMouseEnter={() => setHoveredImage({[project.id]: idx})}
                        onMouseLeave={() => setHoveredImage({})}
                      >
                        <img 
                          src={img} 
                          alt={`${project.name} gallery ${idx + 1}`}
                          style={styles.thumbnailImage}
                        />
                        <div style={{
                          ...styles.thumbnailOverlay,
                          backgroundColor: hoveredImage[project.id] === idx ? 'rgba(0,0,0,0)' : 'rgba(0,0,0,0.3)'
                        }} />
                      </div>
                    ))}
                  </div>
                  {hoveredImage[project.id] !== undefined && (
                    <div style={{
                      position: 'absolute',
                      top: '-20px',
                      left: '0',
                      right: '0',
                      height: '450px',
                      backgroundColor: '#fff',
                      borderRadius: '12px',
                      overflow: 'hidden',
                      boxShadow: '0 12px 40px rgba(0,0,0,0.2)',
                      zIndex: '10',
                      animation: 'fadeIn 0.3s ease'
                    }}>
                      <img 
                        src={project.galleryImages[hoveredImage[project.id]]} 
                        alt={`${project.name} preview`}
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover'
                        }}
                      />
                    </div>
                  )}

                  {project.certifications && project.certifications.length > 0 && (
                    <div style={{...styles.certificationBox, marginTop: '20px'}}>
                      <h4 style={{...styles.sectionTitle, fontSize: '15px', marginBottom: '10px'}}>
                        🏆 Certifications
                      </h4>
                      {project.certifications.map((cert, idx) => (
                        <div key={idx} style={styles.certificationItem}>• {cert}</div>
                      ))}
                    </div>
                  )}

                  {project.specialOffers && project.specialOffers.length > 0 && (
                    <div style={{...styles.offerBox, marginTop: '16px'}}>
                      <h4 style={{...styles.sectionTitle, fontSize: '15px', marginBottom: '10px'}}>
                        🎁 Special Offers
                      </h4>
                      {project.specialOffers.map((offer, idx) => (
                        <div key={idx} style={styles.offerItem}>
                          <span>🌟</span>
                          <span>{offer}</span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {/* Content Column - Right */}
                <div style={styles.contentColumn}>
                  <div>
                    {project.developer && (
                      <div style={styles.developerTag}>{project.developer}</div>
                    )}
                    <h2 style={styles.projectName}>{project.name}</h2>
                    <div style={styles.locationTag}>
                      <span>📍</span>
                      <span>{project.location}</span>
                      <span style={{color: '#2563eb', marginLeft: '8px', fontWeight: '600'}}>
                        • {project.type}
                      </span>
                    </div>
                    <div style={styles.badges}>
                      <div style={styles.badge}>
                        ✓ DTCP Approved
                      </div>
                      <div style={{...styles.badge, ...styles.reraBadge}}>
                        ✓ RERA Approved
                      </div>
                    </div>
                  </div>

                  <p style={styles.description}>{project.description}</p>

                  <div style={styles.infoGrid}>
                    <div style={styles.infoCard}>
                      <div style={styles.infoLabel}>Plot Sizes</div>
                      <div style={styles.infoValue}>{project.plotSizes}</div>
                    </div>
                    <div style={styles.infoCard}>
                      <div style={styles.infoLabel}>Total Plots</div>
                      <div style={styles.infoValue}>{project.totalPlots}</div>
                    </div>
                    <div style={styles.infoCard}>
                      <div style={styles.infoLabel}>Completed Year</div>
                      <div style={styles.infoValue}>{project.completedYear}</div>
                    </div>
                    <div style={styles.infoCard}>
                      <div style={styles.infoLabel}>Status</div>
                      <div style={{...styles.infoValue, color: '#10b981'}}>Ready</div>
                    </div>
                  </div>

                  <div style={styles.amenitiesSection}>
                    <h3 style={styles.sectionTitle}>Key Amenities</h3>
                    <div style={styles.amenitiesGrid}>
                      {project.amenities.slice(0, 8).map((amenity, idx) => (
                        <div key={idx} style={styles.amenityItem}>
                          <span style={styles.checkmark}>✓</span>
                          <span>{amenity}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <>
                {/* Content Column - Left */}
                <div style={styles.contentColumn}>
                  <div>
                    {project.developer && (
                      <div style={styles.developerTag}>{project.developer}</div>
                    )}
                    <h2 style={styles.projectName}>{project.name}</h2>
                    <div style={styles.locationTag}>
                      <span>📍</span>
                      <span>{project.location}</span>
                      <span style={{color: '#2563eb', marginLeft: '8px', fontWeight: '600'}}>
                        • {project.type}
                      </span>
                    </div>
                    <div style={styles.badges}>
                      <div style={styles.badge}>
                        ✓ DTCP Approved
                      </div>
                      <div style={{...styles.badge, ...styles.reraBadge}}>
                        ✓ RERA Approved
                      </div>
                    </div>
                  </div>

                  <p style={styles.description}>{project.description}</p>

                  <div style={styles.infoGrid}>
                    <div style={styles.infoCard}>
                      <div style={styles.infoLabel}>Plot Sizes</div>
                      <div style={styles.infoValue}>{project.plotSizes}</div>
                    </div>
                    <div style={styles.infoCard}>
                      <div style={styles.infoLabel}>Total Plots</div>
                      <div style={styles.infoValue}>{project.totalPlots}</div>
                    </div>
                    <div style={styles.infoCard}>
                      <div style={styles.infoLabel}>Completed Year</div>
                      <div style={styles.infoValue}>{project.completedYear}</div>
                    </div>
                    <div style={styles.infoCard}>
                      <div style={styles.infoLabel}>Status</div>
                      <div style={{...styles.infoValue, color: '#10b981'}}>Ready</div>
                    </div>
                  </div>

                  <div style={styles.amenitiesSection}>
                    <h3 style={styles.sectionTitle}>Key Amenities</h3>
                    <div style={styles.amenitiesGrid}>
                      {project.amenities.slice(0, 8).map((amenity, idx) => (
                        <div key={idx} style={styles.amenityItem}>
                          <span style={styles.checkmark}>✓</span>
                          <span>{amenity}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                {/* Image Column - Right */}
                <div style={styles.imageColumn}>
                  <img 
                    src={project.mainImage} 
                    alt={project.name}
                    style={styles.mainImage}
                  />
                  <div style={styles.galleryContainer}>
                    {project.galleryImages.map((img, idx) => (
                      <div 
                        key={idx}
                        style={styles.thumbnailWrapper}
                        onMouseEnter={() => setHoveredImage({[project.id]: idx})}
                        onMouseLeave={() => setHoveredImage({})}
                      >
                        <img 
                          src={img} 
                          alt={`${project.name} gallery ${idx + 1}`}
                          style={styles.thumbnailImage}
                        />
                        <div style={{
                          ...styles.thumbnailOverlay,
                          backgroundColor: hoveredImage[project.id] === idx ? 'rgba(0,0,0,0)' : 'rgba(0,0,0,0.3)'
                        }} />
                      </div>
                    ))}
                  </div>
                  {hoveredImage[project.id] !== undefined && (
                    <div style={{
                      position: 'absolute',
                      top: '-20px',
                      left: '0',
                      right: '0',
                      height: '450px',
                      backgroundColor: '#fff',
                      borderRadius: '12px',
                      overflow: 'hidden',
                      boxShadow: '0 12px 40px rgba(0,0,0,0.2)',
                      zIndex: '10',
                      animation: 'fadeIn 0.3s ease'
                    }}>
                      <img 
                        src={project.galleryImages[hoveredImage[project.id]]} 
                        alt={`${project.name} preview`}
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover'
                        }}
                      />
                    </div>
                  )}

                  {project.certifications && project.certifications.length > 0 && (
                    <div style={{...styles.certificationBox, marginTop: '20px'}}>
                      <h4 style={{...styles.sectionTitle, fontSize: '15px', marginBottom: '10px'}}>
                        🏆 Certifications
                      </h4>
                      {project.certifications.map((cert, idx) => (
                        <div key={idx} style={styles.certificationItem}>• {cert}</div>
                      ))}
                    </div>
                  )}

                  {project.specialOffers && project.specialOffers.length > 0 && (
                    <div style={{...styles.offerBox, marginTop: '16px'}}>
                      <h4 style={{...styles.sectionTitle, fontSize: '15px', marginBottom: '10px'}}>
                        🎁 Special Offers
                      </h4>
                      {project.specialOffers.map((offer, idx) => (
                        <div key={idx} style={styles.offerItem}>
                          <span>🌟</span>
                          <span>{offer}</span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default CompletedProjects;